// inhale / exhale animation v3
export const defaultTextBottomMargin = 3
export const mobileTextBottomMargin = 1
